import { defineStore } from "pinia";
import http from "@/http";
import {
  LIST_PRIORIDADE,
  ADD_PRIORIDADE,
  UPDATE_PRIORIDADE,
  DEL_PRIORIDADE,
  LIST_ITEM_PRIORIDADE,
  ADD_ITEM_PRIORIDADE,
  UPDATE_ITEM_PRIORIDADE,
  DEL_ITEM_PRIORIDADE,
} from "@/http/url";

export const usePrioridadeStore = defineStore("PrioridadeStore", {
  state: () => {
    return {
      prioridades: [],
      itens: [],
      loaded: false,
    };
  },

  persist: { storage: sessionStorage },

  //Os actions não precisam das mutations, acessam diretamente o state
  actions: {
    LISTAR_PRIORIDADES() {
      return new Promise((resolve, reject) => {
        http
          .get(LIST_PRIORIDADE)
          .then((response) => {
            this.prioridades = response.data;
            this.loaded = true;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_PRIORIDADE(prioridade) {
      return http
        .post(ADD_PRIORIDADE, prioridade)
        .then((response) => this.prioridades.push(response.data))
        .catch((erro) => {
          console.log(erro);
        });
    },

    ALTERAR_PRIORIDADE(prioridade) {
      return http
        .put(`${UPDATE_PRIORIDADE + prioridade.id}`, prioridade)
        .then((response) => {
          const index = this.prioridades.findIndex((objeto) => objeto.id === response.data.id);
          this.prioridades[index] = response.data;
        })
        .catch((erro) => {
          console.log(erro);
        });
    },

    REMOVER_PRIORIDADE(id) {
      return http
        .delete(`${DEL_PRIORIDADE + id}`)
        .then(() => (this.prioridades = this.prioridades.filter((prio) => prio.id != id)));
    },

    LISTAR_ITENS(id) {
      return new Promise((resolve, reject) => {
        http
          .get(`${LIST_ITEM_PRIORIDADE + id}`)
          .then((response) => {
            this.itens = response.data;
            resolve("Ok");
          })
          .catch((erro) => {
            reject(erro);
          });
      });
    },

    CADASTRAR_ITEM(item) {
      return http.post(ADD_ITEM_PRIORIDADE, item).catch((erro) => {
        console.log(erro);
      });
    },

    ALTERAR_ITEM(item) {
      return http.put(`${UPDATE_ITEM_PRIORIDADE + item.id}`, item);
    },

    REMOVER_ITEM(id) {
      return http.delete(`${DEL_ITEM_PRIORIDADE + id}`).then(() => (this.itens = this.itens.filter((item) => item.id != id)));
    },
  },

  //Os getters precisam do state para acesso externo aos componentes
  getters: {
    getPrioridades() {
      return this.prioridades;
    },

    getBySgcq: (state) => {
      return (id) => {
        return state.prioridades.filter((prio) => !id || prio.id == id);
      };
    },

    getPrioridadeLoad(state) {
      return state.loaded;
    },

    getItens(state) {
      return state.itens;
    },

    getSortDatePrioridades: (state) => {
      return (filtro) => {
        let sorted = state.prioridades;
        if (filtro.status != "") {
          sorted = sorted.filter((p) => !filtro || p.status != filtro.status);
        }
        sorted = sorted.filter(
          (p) =>
            !filtro ||
            (p.descricao.includes(filtro.descricao) &&
              p.solicitante.includes(filtro.solicitante) &&
              p.cliente.includes(filtro.cliente))
        );

        sorted = sorted.sort((objA, objB) => Number(new Date(objA.data)) - Number(new Date(objB.data)));

        return sorted;
      };
    },

    getFilterPrioridades: (state) => {
      return (filtro) => {
        let filtrada = state.prioridades;
        if (filtro.status != "") {
          filtrada = filtrada.filter((p) => !filtro || p.status == filtro.status);
        }
        filtrada = filtrada.filter(
          (p) =>
            !filtro ||
            (p.descricao.includes(filtro.descricao) &&
              p.solicitante.includes(filtro.solicitante) &&
              p.cliente.includes(filtro.cliente))
        );

        return filtrada;
      };
    },
  },
});
